module.exports = __webpack_public_path__ + "static/media/02A.f1997ac4.png";